





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Invoice } from '@/store/types/work/invoice';
import WorkHttp from '@/http/WorkHttp';
import Dialog from '@/components/Dialog.vue';
@Component({
  components: { Dialog }
})
export default class ChangeProductReceive extends Vue {
  @Prop() showDialog!: boolean;
  @Prop() outgoing!: boolean;
  @Prop() invoice!: Invoice;
  public loading = false;
  get showCancelBtn () {
    return this.invoice.products_received === true || this.invoice.products_received === null;
  }
  get showConfirmBtn () {
    return this.invoice.products_received === false || this.invoice.products_received === null;
  }
  public changeStatus (status = true) {
    this.loading = true;
    (new WorkHttp(this.invoice.from_enterprise_id)).post({
      url: `/invoices/${this.outgoing ? 'outgoing' : 'income'}/${this.invoice.id}/${status ? 'confirm' : 'cancel'}`
    }).then(res => {
      this.$emit('save');
    }).catch(e => {
      alert('Сталась помилка під час запиту.');
    }).then(_ => {
      this.loading = false;
    });
  }
}
